import * as React from 'react';
import { useSelector } from 'react-redux';

import { TMapBounds } from 'shared/map-search/types/mapBounds';
import { IApplicationState } from 'shared/map-search/types/redux';

import { useFeaturesContext } from '../context';

interface IDetailsVisibilityManagerProps {
  onPromoVisibilityChange(isVisible: boolean): void;
}

export const DetailsVisibilityPromoManager: React.FC<IDetailsVisibilityManagerProps> = ({
  onPromoVisibilityChange,
}) => {
  const { pointsLayer, hotspotsLayer } = useFeaturesContext();
  const promoDetailsVisibilityLevel = useSelector<IApplicationState, number>(
    state => state.promoPinConfig.activeZoomBalloonDetails,
  );
  const { zoom } = useSelector<IApplicationState, TMapBounds>(state => state.mapBounds);

  const isPromoDetailsVisibleByZoom = zoom >= promoDetailsVisibilityLevel;

  React.useEffect(() => {
    pointsLayer.layer.update();
    hotspotsLayer.layer.update();

    onPromoVisibilityChange(isPromoDetailsVisibleByZoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPromoDetailsVisibleByZoom]);

  return null;
};
